import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FiPhone, FiMail } from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import React from 'react'

const Footer = () => {
  return (
    <div className="bg-secondary w-full relative">
      <div className="container mx-auto px-6 py-20">
        
        <div className="flex flex-wrap justify-center text-white gap-10">

        <div className="w-full md:w-1/5 flex flex-col items-center text-center md:items-start md:text-left">
  <Link to="/">
    <img src="/assets/logowt.png" alt="Param Logo" className="w-32 h-auto md:w-40 mb-6" />
  </Link>
</div>

          {/* Column 1 - Logo & About Us */}
          <div className="w-full md:w-1/5 flex flex-col items-center text-center md:items-start md:text-left">
            <h2 className="text-lg font-semibold">Follow Us :</h2>
            <div className="flex space-x-4 mt-4">
              <a href="https://www.facebook.com/paramlifewellness" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#642819] hover:bg-gray-600 transition">
                <FaFacebookF className="text-white text-lg" />
              </a>
              <a href="https://www.instagram.com/paramlifeofficial/#" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#642819] hover:bg-gray-600 transition">
                <FaInstagram className="text-white text-lg" />
              </a>
              <a href="https://www.linkedin.com/company/param-life/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#642819] hover:bg-gray-600 transition">
                <FaLinkedinIn className="text-white text-lg" />
              </a>
              <a href="https://www.youtube.com/@ParamLifeOfficial " target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#642819] hover:bg-gray-600 transition">
                <FaYoutube className="text-white text-lg" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="w-full md:w-1/5 flex flex-col items-center md:items-start text-center md:text-left">
            <h2 className="text-lg font-semibold">Quick Links</h2>
            <ul className="mt-2 space-y-1 text-sm">
              <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-gray-300">Privacy Policy</Link></li>
              <li><Link to="/cancellation-refund-policy" className="hover:text-gray-300">Refund Policy</Link></li>
              <li><Link to="/about" className="hover:text-gray-300">About Us</Link></li>
              <li><Link to="/terms-and-conditions" className="hover:text-gray-300">Terms And Conditions</Link></li>
              <li><Link to="/user-data-deletion" className="hover:text-gray-300">User Data Deletion Policy</Link></li>

            </ul>
          </div>
          <div className="w-full md:w-1/5 flex flex-col items-center md:items-start text-center md:text-left mx-auto">
  <h2 className="text-lg font-semibold">Contact Info</h2>
  
  <div className="mt-2 space-y-3 text-sm w-full flex flex-col items-center md:items-start">
    
    {/* Company Name */}
    <div className="flex items-center gap-2">
      <span className="text-white hover:text-gray-400 transition text-md">Param Life Wellness Pvt. Ltd.</span>
    </div>
    
    {/* Email */}
<div className="flex items-center gap-2">
  <FiMail className="text-white hover:text-gray-400 transition text-xl" />
  <a href="mailto:info@param.life" className="text-left mr-10 whitespace-nowrap text-white hover:text-gray-400 transition">
    info@param.life
  </a>
</div>

{/* Phone */}
<div className="flex items-center gap-2">
  <FiPhone className="text-white hover:text-gray-400 transition text-xl" />
  <a href="tel:+919403891050" className="text-left text-white hover:text-gray-400 transition">
    +91 9403891050,
  </a>
  <a href="tel:+918279445944" className="text-left text-white hover:text-gray-400 transition">
    8279445944
  </a>
</div>

    
    {/* Address */}
    <div className="flex flex-col items-center md:items-start space-y-4 w-full">
      
      {/* Corporate Address */}
      <div className="flex items-start gap-2 w-full justify-center md:justify-start">
        <IoLocationOutline className="text-white hover:text-gray-400 transition text-xl md:text-2xl" />
        <div className="text-left">
          <span className="block font-semibold">Corporate Address:</span>
          <span className="block">
            No. 289, Arcadia Grant, <br />
            Badowala, Prem Nagar, <br />
            Dehradun, Uttarakhand - 248007
          </span>
        </div>
      </div>

      {/* Registered Address */}
      <div className="flex items-start gap-2 w-full justify-center md:justify-start">
        <IoLocationOutline className="text-white hover:text-gray-400 transition text-xl md:text-2xl" />
        <div className="text-left">
          <span className="block font-semibold">Regd. Address:</span>
          <span className="block">
            No. 2539, Shivpuri, <br />
            Kurwar Road, Niralanagar, <br />
            Sultanpur, Uttar Pradesh - 228001
          </span>
        </div>
      </div>

    </div>
  </div>
</div>


        </div>
      </div>

      {/* Bottom Border - Fixed Positioning */}
      <div className="bg-[#F9A01B] text-center text-white py-3 text-sm w-full">
        Copyright © 2025 Param Life. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
